import React from 'react'
import Bowser from 'bowser'
import Ajax from '../../../../utils/ajax'
import Config from '../../../../config'
import createReactClass from 'create-react-class'


var PhotoOrganiserLogin = createReactClass({
    mounted: false,

	getInitialState: function () {
		return {loginUrl: null}
	},
	componentDidMount: function () {
		var self = this;
        self.mounted = true;

		//After we have opened the external login page in the iframe, and
		//the user has logged in, it will redirect the iframe to the returnUrl
		//where we will capture the access token and send to parent window to be stored
		var returnUrl = window.location.href;
		if (returnUrl.indexOf("#") > -1) {
			returnUrl = returnUrl.substr(0, returnUrl.lastIndexOf('#'));
		}
		if (returnUrl.indexOf("?") > -1) {
			returnUrl = returnUrl.substr(0, returnUrl.lastIndexOf('?'));
		}
		if (returnUrl.indexOf("/") > -1) {
			returnUrl = returnUrl.substr(0, returnUrl.lastIndexOf('/'));
		}
		returnUrl = returnUrl + '/iframeLoginRedirect.html';

		Ajax.get({
			url: Config.PhotoOrganiseAuthApi + '/api/v1/account/externalLogins?returnUrl=' + encodeURIComponent(returnUrl) + '&generateState=true',
			responseType: 'JSON'
		}).then (function (result) {
			if (result.openIdConnect) {
				if (self.mounted) {
					var newUrl = result.openIdConnect.url.replace(/loginTheme=([^&]*)/, "loginTheme=stripped.$1");
					// Organise login is hard wired to FotoKnudsen, need to replace it with the correct vendor id!
					// yes, this is a backend problem solved in the frontend... GAH!
					var storedChannel = sessionStorage.getItem("channel");
					var channel = ( storedChannel === "albelli.se" ) ? "onskefoto.se" : storedChannel;
					newUrl = newUrl.replace( "fotoknudsen.no", channel );
					self.setState({loginUrl: newUrl});
				}
			}
		}).catch(function (error) {
			displayError(_("Cannot login into Photo Organise because we encountered an error upon presenting the login form. Hopefully this will be resolved shortly, if not, contact customer care."), {error: error});
		});
	},

	/**
	 * Open login for Safari.
	 */
	openLogin: function() {
		this.windowReference = window.open(this.state.loginUrl);
	},

	render: function() {
		if (this.state.loginUrl === null) {
			return (
				<div>
					{_("Loading, please wait")}
				</div>
			);
		} else {
			if (Bowser["safari"]) {
				return (
					<div className="main login">
						<div className="title-login">{_('Please log in with')}</div>
						<button className="small button" onClick={this.openLogin}>
							{Config.VendorVariables[sessionStorage.getItem("vendor")].copyrightName}
						</button>
					</div>
				);
			}
			return (
				<iframe src={this.state.loginUrl} id="loginiframe" style={{display: "block", margin: "0px auto", height: "670px", width: "100%", border: "0px"}}></iframe>
			);
		}
	},
    componentWillUnmount: function () {
        this.mounted = false;
    }
});

export default PhotoOrganiserLogin;
